export default "__VITE_ASSET__BCONopRg__"